import type { FC } from "react"

const Cross: FC = () => {
  return (
    <svg width="8" height="8" className="ml-2" viewBox="0 0 8 8" fill="none">
      <path
        d="M1.59082 6.99995L4.31807 3.99998L1.59082 1M7.18169 7L4.45444 4.00002L7.18169 1.00005"
        stroke="currentColor"
        strokeWidth="1.49999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Cross
